import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';
import responsiveAlignment from '../Base/responsiveAlignment';
import {parseResponsiveProperty} from '@converdy/styles';

export default ({gridColor}) => {
  const jss = {
    root: {},
  };

  return jss;
};
